import(/* webpackMode: "eager", webpackExports: ["AppHomePageSkeleton"] */ "/calcom/apps/web/app/(use-page-wrapper)/apps/(homepage)/skeleton.tsx");
